// extracted by mini-css-extract-plugin
module.exports = {"CreatePage":"page_CreatePage__3TdPs","show":"page_show__iWKMu"};